module.exports = __webpack_public_path__ + "img/b_20.0cfaefd7.jpg";